module.exports = __webpack_public_path__ + "static/the-vagina-monologues-688a5ba60af0d4ff80ae0492c9432719.jpg";